import React, { useState, useEffect } from "react"
import { BrowserRouter, Routes, Route } from "react-router-dom"
import UAI from "./UAI"
import Loading from "./Utils/Loading"
import UAINavbar from "./Utils/UAINavbar"
import Cohortes from "./Cohortes/Cohortes"
import "./Main.css"
import { UsuarioContext } from "./Context/Usuario"
import Usuario from "./Usuario"
import MigasDePan from "./Utils/MigasDePan"
import localforage from "localforage"
import packageJson from "./version.json"
import log from "loglevel"
import { cloneDeep } from "lodash"
import Tour from "reactour"
import tutoriales from "./Tutoriales/Tutoriales"
import Ayuda from "./Ayuda"
import Home from "./Dashboard/Home"
import ErrorMP from "./Utils/ErrorMP"
import UAISideBar from "./Utils/UAISideBar"
import { Col, Container, Row } from "react-bootstrap"
import { MdArrowLeft, MdArrowRight } from "react-icons/md"

/**
 * Componente principal de la aplicación, que gestiona los datos a obtener del
 * usuario y las rutas para las funcionalidades a visualizar
 **/
const Main = (props) => {
  // Nombre de usuario
  const [nombreUsuario, setNombreUsuario] = useState(props.usuario)
  // Periodo actual
  const [periodo, setPeriodo] = useState(props.periodo)
  // Objeto usuario
  const [usuario, setUsuario] = useState(null)
  // Variables de progreso de la carga de datos
  const [progreso, setProgreso] = useState(0)
  // Mensaje que se mostrará durante el progreso cambia
  const [mensajeProgreso, setMensajeProgreso] = useState(
    "Cargando Maestro de Programas " + props.usuario
  )
  // Variable para indicar si el tour se abre o no
  const [openTour, setOpenTour] = useState(null)
  // Si el menú está expandido
  const [expand, setExpand] = useState(true)

  const toggleExpand = () => {
    setExpand(!expand)
  }


  useEffect(() => {
    /**
     * Crea un objeto usuario a partir de un nombre de usuario y un período
     * @param {String} nombreUsuario
     */
    const obtieneUsuario = (nombreUsuario) => {
      let usuarioTmp = new Usuario(
        nombreUsuario, // Nombre del usuario
        periodo, // Periodo
        (mensajeProgreso, progreso) => {
          setMensajeProgreso(mensajeProgreso)
          setProgreso(progreso)
        },
        () => {
          setUsuario(usuarioTmp)
        },
        (error) => {
          console.error(error)
          setUsuario({ error: true, details: error })
        }
      )
    }

    let storage = window.localStorage

    UAI.logLineaDelimitadorGruesa()
    log.info("Universidad Adolfo Ibáñez (c) 2018-2022")
    UAI.logLineaDelimitador()
    log.info("Inicializando Panel Online - Maestro de Programas")
    log.info(
      "Versión: " +
        packageJson.version +
        " Caché: " +
        storage.getItem("version")
    )
    log.info("Período: " + periodo)
    log.info(
      "Ambiente:" +
        process.env.REACT_APP_ENVIRONMENT +
        " URL base:" +
        UAI.basename() +
        " URL postula:" +
        UAI.basePostula()
    )
    log.info("Fecha: " + new Date().toLocaleDateString("es-CL"))
    UAI.logLineaDelimitadorGruesa()

    UAI.obtieneConfiguracionInicial(
      (results) => {
        log.info(
          "Configuración inicial cargada (usuarios en el MP, facultades, unidades de venta y atributos)"
        )
        obtieneUsuario(nombreUsuario)
      },
      (error) => {
        log.error(error)
        setUsuario({ error: true, details: error })
      },
      () => {
        setProgreso((prev) => {
          return Math.min(50, prev + 5)
        })
      }
    )
  }, [periodo, nombreUsuario])

  /**
   *
   * @param {String} _periodo
   */
  const cambiarPeriodo = (_periodo) => {
    let periodonumero = parseInt(_periodo)
    let thisyear = new Date().getFullYear()
    log.info("Cambiando periodo a " + periodonumero)
    if (periodonumero < 2012 || periodonumero > thisyear + 1) {
      throw new Error("Valor inválido para el período!")
    }
    let storage = window.localStorage
    log.debug(
      "Guardando nuevo período " +
        periodonumero +
        " en periodo-" +
        nombreUsuario
    )
    storage.setItem("periodo-" + nombreUsuario, periodonumero)
    setPeriodo(periodonumero)
    setUsuario(null)
  }

  /**
   *
   * @param {*} _usuario
   */
  const cambiarUsuario = (_usuario) => {
    let storage = window.localStorage
    log.info("Impersonando a " + _usuario)
    if (UAI.permisosImpersonar[props.accountInfo.username]) {
      storage.setItem("impersonar", _usuario)
      setMensajeProgreso("Cargando usuario " + _usuario)
      setUsuario(null)
      setNombreUsuario(_usuario)
    } else {
      log.error(
        "Usuario " +
          props.accountInfo.username +
          " no tiene permiso para impersonar a " +
          _usuario
      )
    }
  }

  /**
   *
   */
  const limpiarCache = () => {
    log.info("Limpiando caché")
    localforage.clear().then(() => {
      let storage = window.localStorage
      storage.removeItem("columnscohortes")
      storage.removeItem("columnspostulantes")
      window.location.href = UAI.wwwroot() + window.location.pathname
    })
  }

  /**
   *
   * @param {*} vista
   */
  const reload = (vista) => {
    log.debug("Esto debería hacer reload de los cohortes solamente")
    usuario.reloadView(vista)
  }

  /**
   *
   * @param {*} _nuevaFecha
   */
  const setFechaReporte = (_nuevaFecha) => {
    log.debug(
      "Deberíamos estar actualizando la fecha del reporte, sin embargo al parecer no funciona"
    )
    log.debug(_nuevaFecha)
    let _usuario = cloneDeep(usuario)
    _usuario.fechaReporte = _nuevaFecha
    // setUsuario(_usuario)
  }

  /**
   *
   */
  const closeTour = () => {
    setOpenTour(null)
  }

  /**
   *
   * @param {*} _newusuario
   * @param {*} _changes
   * @returns
   */
  const setUsuarioImpl = async (_newusuario, _changes) => {
    return new Promise((resolve, reject) => {
      log.debug("Yeah! Usando context updates con setUsuario")
      localforage
        .getItem("cohortes-" + usuario.username + "-" + usuario.periodo)
        .then((cachecohortes) => {
          log.debug(cachecohortes)
          if (cachecohortes !== undefined && cachecohortes !== null) {
            let cohortesperiodo = cachecohortes.data
            if (cohortesperiodo !== undefined) {
              _changes.Solicitudes.forEach((solicitud) => {
                let _cohorteId = solicitud.CohorteId
                let cohorteIdx = cohortesperiodo.Cohortes.findIndex((coh) => {
                  return coh.CohorteId === _cohorteId
                })
                let cohorteorig = cohortesperiodo.Cohortes.find((coh) => {
                  return coh.CohorteId === _cohorteId
                })
                let nuevocohorte = _newusuario.cohortes[_cohorteId]
                cohorteorig.CohortesSalida = nuevocohorte
                if (cohorteIdx >= 0) {
                  cohortesperiodo.Cohortes.splice(cohorteIdx, 1, cohorteorig)
                }
              })
              localforage
                .setItem(
                  "cohortes-" + usuario.username + "-" + usuario.periodo,
                  cachecohortes
                )
                .then(() => {
                  setUsuario(_newusuario)
                  resolve()
                })
                .catch((error) => {
                  reject(error)
                })
            } else {
              log.warn("No existe data para el período aunque existe el caché!")
              reject()
            }
          } else {
            setUsuario(_newusuario)
            resolve()
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  /**
   *
   * @param {*} cohortesPorPeriodo
   */
  const agregarCohortesUsuarioImpl = (cohortesPorPeriodo) => {
    log.debug("Agregando cohortes!")
    log.debug(cohortesPorPeriodo)
    UAI.agregarCohortesCache(
      cohortesPorPeriodo,
      () => {
        cohortesPorPeriodo.forEach((cohortesPeriodo) => {
          usuario.agregarCohortes(
            cohortesPeriodo.Cohortes,
            usuario.periodo,
            usuario,
            JSON.parse(JSON.stringify(UAI.configuracion.unidadesventa))
          )
        })
      },
      (e) => {
        log.error(e)
        throw new Error(e)
      }
    )
  }

  if (!usuario || (usuario && usuario.error)) {
    return (
      <>
        <UsuarioContext.Provider
          value={{
            usuario: usuario,
            setUsuario: setUsuarioImpl,
            setFechaReporte,
            agregarCohortesUsuario: agregarCohortesUsuarioImpl,
          }}
        >
          <BrowserRouter basename={UAI.basename()}>
            <UAINavbar
              usuarioAD={props.accountInfo}
              periodo={periodo}
              CambiarPeriodo={cambiarPeriodo}
              CambiarUsuario={cambiarUsuario}
              LimpiarCache={limpiarCache}
              loading={true}
            />
            <div className="mp-container">
              {(!usuario || (usuario && !usuario.error)) && (
                <div className="main-loading">
                  <Loading
                    message={mensajeProgreso}
                    progress={progreso}
                    videoTutorial={true}
                  />
                </div>
              )}
              {usuario && usuario.error && (
                <ErrorMP>
                  <p className="h4">
                    No hemos encontrado información de su usuario en el sistema
                    Postula
                  </p>
                  <p>{usuario.error}</p>
                  <p>Existen dos posibles causas para este problema:</p>
                  <table>
                    <tr>
                      <td>
                        Que su usuario no tenga permisos sobre ningún cohorte en
                        el{" "}
                        <a href="https://fin.uai.cl/Postgrado/Admin/Login">
                          sistema Postula UAI
                        </a>
                        . Si esto no corresponde por favor contacte a{" "}
                        {UAI.administrador}.
                      </td>
                      <td>
                        Que estemos sin conexión con el{" "}
                        <a href="https://fin.uai.cl/Postgrado/Admin/Login">
                          sistema Postula UAI
                        </a>
                        . Por favor intente más tarde.{" "}
                        <a href="https://fin.uai.cl/Postgrado/Admin/Login">
                          Ir a Postula
                        </a>
                      </td>
                    </tr>
                  </table>
                </ErrorMP>
              )}
            </div>
          </BrowserRouter>
        </UsuarioContext.Provider>
      </>
    )
  }

  if (
    window.location.pathname === "/" &&
    usuario.defaultView &&
    usuario.defaultView.path &&
    usuario.defaultView.path !== "/"
  ) {
    window.location.href = UAI.basename() + usuario.defaultView.path
    return <></>
  }

  return (
    <UsuarioContext.Provider
      value={{
        usuario: usuario,
        setUsuario: setUsuarioImpl,
        setFechaReporte,
        agregarCohortesUsuario: agregarCohortesUsuarioImpl,
      }}
    >
      <BrowserRouter basename={UAI.basename()}>
        <UAINavbar
          usuarioAD={props.accountInfo}
          periodo={periodo}
          CambiarPeriodo={cambiarPeriodo}
          CambiarUsuario={cambiarUsuario}
          LimpiarCache={limpiarCache}
          openTour={openTour}
        />
        {process.env.REACT_APP_ENVIRONMENT !== "prod" &&
          tutoriales[openTour] && (
            <Tour
              steps={tutoriales[openTour].steps}
              isOpen={openTour !== null}
              onRequestClose={closeTour}
            />
          )}
        <Container fluid>
          <Row>
            <Col className="left-sidebar p-0"  style={{maxWidth: !expand ? "4rem":"10rem"}}>
            <div className="text-right w-100" onClick={() => {
    toggleExpand()
  }}>{expand ? <MdArrowLeft style={{color:"white",fontSize:"1.5rem", float:"right"}} role="button"></MdArrowLeft> : <MdArrowRight style={{color:"white",fontSize:"1.5rem", float:"right"}} role="button"></MdArrowRight>}&nbsp;</div>
              <UAISideBar usuarioAD={props.accountInfo} periodo={periodo} expand={expand}/>
            </Col>
            <Col className="mp-container">
              <Routes>
                <Route
                  path="/ayuda"
                  element={
                    <>
                      <MigasDePan
                        view={usuario.views.find((v) => {
                          return v.path === "/ayuda"
                        })}
                        external={true}
                        setOpenTour={setOpenTour}
                      />
                      <Ayuda setOpenTour={setOpenTour} />
                    </>
                  }
                ></Route>
                {usuario.views
                  .filter((_view) => {
                    return _view.path !== "/ayuda"
                  })
                  .map((view, idx) => {
                    if (view.external) {
                      return (
                        <Route
                          path={view.path}
                          key={"view-" + idx}
                          element={
                            <>
                              <MigasDePan
                                view={view}
                                external={true}
                                setOpenTour={setOpenTour}
                              />
                              {view.content}
                            </>
                          }
                        ></Route>
                      )
                    } else {
                      return (
                        <Route
                          path={"/cohortes/" + view.key + "/:facultad"}
                          key={"view-" + idx}
                          element={
                            <>
                              <MigasDePan
                                view={view}
                                setOpenTour={setOpenTour}
                              />
                              <Cohortes view={view} reload={reload} />
                            </>
                          }
                        ></Route>
                      )
                    }
                  })}
                <Route
                  path="/"
                  element={
                    <>
                      <MigasDePan
                        view={UAI.vistas["home"]}
                        setOpenTour={setOpenTour}
                      />
                      <Home />
                    </>
                  }
                ></Route>
              </Routes>
            </Col>
          </Row>
        </Container>
        <footer className="footer bg-dark">
          <div xs="12" className="text-center">
            <small className="text-muted">
              <a href="https://www.uai.cl" className="nav-link">
                Panel Online {packageJson.version} - Sistemas de Admisión @Copyright 2018-2021 Universidad Adolfo Ibáñez.
              </a>
            </small>
          </div>
        </footer>
      </BrowserRouter>
    </UsuarioContext.Provider>
  )
}

export default Main
